/**
 * @generated SignedSource<<aad1aebc8d0185ebcc6eb3b0eec9b07a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublisherReportGraph_site$data = {
  readonly reportPublisher: any;
  readonly " $fragmentType": "PublisherReportGraph_site";
};
export type PublisherReportGraph_site = PublisherReportGraph_site$data;
export type PublisherReportGraph_site$key = {
  readonly " $data"?: PublisherReportGraph_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"PublisherReportGraph_site">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "input"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PublisherReportGraph_site",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "input",
          "variableName": "input"
        }
      ],
      "kind": "ScalarField",
      "name": "reportPublisher",
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};

(node as any).hash = "12e4bcb8c6a0e499ef1bcafeee423b4f";

export default node;
